import { render, staticRenderFns } from "./MultistepSummary.vue?vue&type=template&id=108b2451"
import script from "./MultistepSummary.vue?vue&type=script&lang=js"
export * from "./MultistepSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports